import { jsxs as e, jsx as l } from "react/jsx-runtime";
import { DEFAULT_METRIC_ICON_SIZE as i } from "./index.es2447.js";
function H({ size: C = i }) {
  return /* @__PURE__ */ e("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", width: C, height: C, children: [
    /* @__PURE__ */ l("rect", { width: "56", height: "56", rx: "3", fill: "#F3F3FD" }),
    /* @__PURE__ */ l(
      "path",
      {
        d: "M16.7781 26L16.0296 39.4723C16.0137 39.7589 16.2418 40 16.5288 40H26.1384C26.4254 40 26.6535 39.7589 26.6376 39.4723L25.8892 26H25.885L25.893 26.1423C25.9091 26.429 25.6809 26.6703 25.3938 26.6703H17.2719C16.9851 26.6703 16.757 26.4295 16.7726 26.1431L16.7804 26H16.7781Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ l(
      "path",
      {
        d: "M17.2715 26.6703H25.3934C25.6805 26.6703 25.9087 26.429 25.8926 26.1423L25.3236 16H17.324L16.7722 26.1432C16.7567 26.4295 16.9847 26.6703 17.2715 26.6703Z",
        fill: "#E1E2FF"
      }
    ),
    /* @__PURE__ */ l(
      "path",
      {
        d: "M37.3333 31.1666C37.3333 30.8905 37.1095 30.6666 36.8333 30.6666H33.8333C33.5572 30.6666 33.3333 30.8905 33.3333 31.1666V35.5C33.3333 35.7761 33.5572 36 33.8333 36H36.8333C37.1095 36 37.3333 35.7761 37.3333 35.5V31.1666Z",
        fill: "#E1E2FF"
      }
    ),
    /* @__PURE__ */ l(
      "path",
      {
        d: "M31.4998 30.6666C31.776 30.6666 31.9998 30.8905 31.9998 31.1666V35.5C31.9998 35.7761 31.776 36 31.4998 36H28.4998C28.2237 36 27.9998 35.7761 27.9998 35.5V31.1666C27.9998 30.8905 28.2237 30.6666 28.4998 30.6666H31.4998Z",
        fill: "#E1E2FF"
      }
    ),
    /* @__PURE__ */ l(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M36.8335 30.6666C37.1096 30.6666 37.3335 30.8905 37.3335 31.1666V35.5C37.3335 35.7761 37.1096 36 36.8335 36H33.8335C33.5574 36 33.3335 35.7761 33.3335 35.5V31.1666C33.3335 30.8905 33.5574 30.6666 33.8335 30.6666H36.8335ZM36.3335 31.6666V35H34.3335V31.6666H36.3335Z",
        fill: "#5E63E5"
      }
    ),
    /* @__PURE__ */ l(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M31.5 30.6666C31.7761 30.6666 32 30.8905 32 31.1666V35.5C32 35.7761 31.7761 36 31.5 36H28.5C28.2239 36 28 35.7761 28 35.5V31.1666C28 30.8905 28.2239 30.6666 28.5 30.6666H31.5ZM31 31.6666V35H29V31.6666H31Z",
        fill: "#5E63E5"
      }
    ),
    /* @__PURE__ */ l(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25.3598 16.4723C25.358 16.4392 25.353 16.4071 25.3451 16.3761L25.324 16H17.3243L16.8908 23.97L16.0296 39.4723C16.0137 39.7589 16.2418 40 16.5288 40H26.1384L26.146 39.9999H38.9998C39.5521 39.9999 39.9998 39.5522 39.9998 38.9999V24.7385C39.9998 24.3847 39.6425 24.1428 39.3141 24.2742L33.3331 26.6666L32.2234 24.4472C32.0999 24.2002 31.7996 24.1001 31.5526 24.2235L25.9462 27.0267L25.3598 16.4723ZM26.0066 28.1146L26.6114 38.9999L38.9998 38.9999V25.477L33.7045 27.5951C33.2216 27.7882 32.6713 27.579 32.4387 27.1138L31.5526 25.3416L26.0066 28.1146ZM24.3785 17L24.8649 25.6703H17.7998L17.8893 24.0254L18.2796 17H24.3785ZM17.7424 26.6703H24.9249L25.6098 39H17.0574L17.7424 26.6703Z",
        fill: "#5E63E5"
      }
    )
  ] });
}
H.__tags = ["industry"];
export {
  H as MetricIndustrialIcon
};
//# sourceMappingURL=index.es415.js.map
